import {Box, Typography} from '@mui/material';
import {Trans, useTranslation} from 'react-i18next';

import './styles';
import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon';
import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';
import {IMAGES} from '@/constants/images';
import {COLORS} from '@/styles/colors';

import {ViewModelProvider} from '../../ViewModelContext';

import {useActions} from './useActions';

const PasswordChangedContent = () => {
  const {t} = useTranslation();
  const {isMobile, handleOpenDownloadApp} = useActions();

  return (
    <Box className="password-changed-container">
      <Box
        className="logo"
        component="img"
        src={IMAGES.LOGO_TEXT_BLACK.src}
        alt="Check"
      />
      {isMobile ? (
        <>
          <Box
            className="password-changed-container-icon"
            component="img"
            src={IMAGES.CHECK.src}
            alt="Check"
          />
          <Typography className="password-changed-title">
            {t('password_change_page.title')}
          </Typography>
          <Typography className="password-changed-subtitle">
            {t('password_change_page.sub_title')}
          </Typography>

          <ButtonContainer sticky>
            <AppButton
              id="password-changed-download-app-button"
              iconRight={
                <FuseSvgIcon
                  size={12}
                  sx={{color: COLORS.WHITE}}>
                  heroicons-outline:arrow-up-right
                </FuseSvgIcon>
              }
              label={t('password_change_page.button')}
              onClick={handleOpenDownloadApp}
              variant={AppButtonVariant.onPrimary}
            />
          </ButtonContainer>
        </>
      ) : (
        <>
          <Typography className="password-changed-title">
            {t('password_change_page.title')}
          </Typography>
          <Box
            className="logo"
            component="img"
            src={IMAGES.DOWNLOAD_QR.src}
            width={IMAGES.DOWNLOAD_QR.width}
            height={IMAGES.DOWNLOAD_QR.height}
            alt="DOWNLOAD_QR"
          />

          <Box className="password-changed-description-container">
            <Typography className="password-changed-description-title">
              <Trans i18nKey="password_change_page.description" />
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

const PasswordChangedPage = () => (
  <ViewModelProvider>
    <PasswordChangedContent />
  </ViewModelProvider>
);

export default PasswordChangedPage;
